import VueRouter from 'vue-router'
import Vue from 'vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'FavList',
    meta: {
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "FavList" */'views/FavList.vue')
  },
  {
    path: '/search',
    name: 'FavSearch',
    meta: {
      keepAlive: false
    },
    component: () => import(/* webpackChunkName: "FavSearch" */'views/FavSearch.vue')
  },
  {
    path: '/detail',
    name: 'FavDetail',
    meta: {
      keepAlive: false
    },
    component: () => import(/* webpackChunkName: "FavDetail" */'views/FavDetail.vue')
  }
]

export default new VueRouter({
  mode: 'hash',
  routes
})
